import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Marketplace = () => {
  const [nfts, setNfts] = useState([
    {
      name: "TITULO",
      val: "0,01",
      price: "300,00€",
      img: "./images/nft21.png",
    },
    {
      name: "TITULO",
      val: "0,01",
      price: "300,00€",
      img: "./images/nft22.png",
    },
    {
      name: "TITULO",
      val: "0,01",
      price: "300,00€",
      img: "./images/nft21.png",
    },
    {
      name: "TITULO",
      val: "0,01",
      price: "300,00€",
      img: "./images/nft22.png",
    },
    {
      name: "TITULO",
      val: "0,01",
      price: "300,00€",
      img: "./images/nft21.png",
    },
    {
      name: "TITULO",
      val: "0,01",
      price: "300,00€",
      img: "./images/nft22.png",
    },
    {
      name: "TITULO",
      val: "0,01",
      price: "300,00€",
      img: "./images/nft21.png",
    },
    {
      name: "TITULO",
      val: "0,01",
      price: "300,00€",
      img: "./images/nft22.png",
    },
  ]);
  return (
    <div className="marketplace-page flex">
      <div className="wrap wrapWidth flex flex-col">
        <div className="page-tag">Marketplace</div>
        <div className="nfts-search flex justify-end">
          <div className="searc-box flex aic">
            <div className="lbl">Ordenar por</div>
            <div className="txt-box flex aic">
              <input
                type="text"
                className="txt cleanbtn"
                Placeholder="Recientemente añadido"
              />
              <div className="ico">
                <img src="./images/dropdownIcon.png" className="img" />
              </div>
            </div>
          </div>
        </div>
        <div className="marketplace-block flex">
          <div className="left flex flex-col">
            <div className="le-tag">Filtrado</div>
            <div className="left-side">
              <div className="tag">RANGO DE PRECIOS</div>
              <div className="row flex aic">
                <input type="text" className="txt" Placeholder="Min" />
                <div className="lbl">A</div>
                <input type="text" className="txt" Placeholder="Max" />
              </div>
              <div className="row flex aic jc flex-col">
                <div className="tag">PAÍS</div>
                <input type="text" className="txt w-full" Placeholder="PAÍS" />
              </div>
              <div className="row flex aic jc flex-col">
                <div className="tag">Categoría</div>
                <input
                  type="text"
                  className="txt w-full"
                  Placeholder="Categoría"
                />
              </div>
              <div className="row flex aic jc flex-col">
                <div className="tag">Disponibilidad</div>
                <div className="check-box flex aic w-full">
                  <input type="checkbox" className="c-box mr-2" />
                  <div className="lbl">Comprar ahora</div>
                </div>
                <div className="check-box flex aic w-full ">
                  <input type="checkbox" className="c-box mr-2" />
                  <div className="lbl">Precio de reserva</div>
                </div>
                <div className="check-box flex aic w-full ">
                  <input type="checkbox" className="c-box mr-2" />
                  <div className="lbl">Subasta</div>
                </div>
                <div className="check-box flex aic w-full ">
                  <input type="checkbox" className="c-box mr-2" />
                  <div className="lbl">Oferta activa </div>
                </div>
              </div>
              <div className="row flex aic jc flex-col">
                <div className="tag">Tipo</div>
                <div className="check-box flex aic w-full">
                  <input type="checkbox" className="c-box mr-2" />
                  <div className="lbl">Físico</div>
                </div>
                <div className="check-box flex aic w-full">
                  <input type="checkbox" className="c-box mr-2" />
                  <div className="lbl">Imagen</div>
                </div>
                <div className="check-box flex aic w-full">
                  <input type="checkbox" className="c-box mr-2" />
                  <div className="lbl">Vídeo</div>
                </div>
              </div>
              <div className="row flex aic jc flex-col">
                <div className="tag">BLOCKCHAIN</div>
                <div className="check-box flex aic w-full">
                  <input type="checkbox" className="c-box mr-2" />
                  <div className="lbl">Ethereum</div>
                </div>
                <div className="check-box flex aic w-full">
                  <input type="checkbox" className="c-box mr-2" />
                  <div className="lbl">Polygon</div>
                </div>
              </div>
              <div className="row flex aic jc flex-col">
                <div className="btn button">buscar</div>
              </div>
            </div>
          </div>
          <div className="right flex">
            <div className="nfts-side">
              {nfts.map((item, index) => (
                <div className="nft-card flex flex-col">
                  <div
                    className="nft-img flex"
                    style={{ backgroundImage: `url(${item.img})` }}
                  >
                    <div className="about-auth flex aic">
                      <img
                        src="./images/auth_users2.png"
                        className="user-img"
                      />
                      <div className="user-tag">@autor</div>
                    </div>
                  </div>
                  <div className="nft-info flex flex-col">
                    <div className="name">TITULO</div>
                    <div className="actions flex aic jc">
                      <img src="./images/Ethereum.svg" className="ico" />
                      <div className="meta flex flex-col aic">
                        <div className="val">0,01</div>
                        <div className="price">300,00€</div>
                      </div>
                      <Link to="/NftDetail" className="btn button">
                        COMPRAR
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="see-more flex aic jc">
          <div className="btn button">VER MÁS</div>
        </div>
      </div>
    </div>
  );
};

export default Marketplace;
